import * as React from "react"
import { Link } from "gatsby"
import { StaticImage } from "gatsby-plugin-image"
import Layout from "../components/layout"
import Seo from "../components/seo"

const ExtraEventPage = () => (
  <Layout>
    <Seo title="More to Do" />
    <div className="info-page-layout">
        <div className="page-header">
          <h1>
            <strong>Extra Evemts</strong>
          </h1>
          <hr />
          <a href="/registration/" className="btn green-button-outline">
          Add These Events to Your Registration!
      </a>
      <h3>
      To be added to a wait list for sold out events, please email rgiambrone@centerforinquiry.org </h3>
        </div>
        {/*Event List Grid*/}
      <div className="ex-event-list">
      <main className="ex-event-grid">
      <div className="ex-event-item">
        <StaticImage
          src="../images/CFI Front Headquarters 2025.jpg"
          alt="The Center for Inquiry History and Mystery Tour"
          height="100%"
          loading="lazy"
          placeholder="tracedSVG"
          className="ex-event-img"
          />
        <div className="ex-event-text">
        <h2>
        The Center for Inquiry History and Mystery Tour
          </h2>
          <h5>
            <p>Thursday, June 11th | 8:00 AM–11:30 AM [Sold Out]</p>
            <p>Thursday, June 11th | 10:00 AM-1:30 PM [Sold Out]</p>
          </h5>
          <p>
          Experience the history of organized skepticism during a tour through the headquarters of the
          Center for Inquiry. CFI's Chief Investigator Kenny Biddle will tell tales of the most intriguing
          curiosities in the center, and CFI's Director of Libraries Tim Binga will guide you through the
          building discussing the history and architecture while taking you through CFI's extensive
          collection of books authored by – and even owned by – the world's greatest mystery solvers,
          skeptics, and freethinkers.    
           <b> Admission for this event is $64.</b>



          </p>
        </div>
        </div>
       
        <div className="ex-event-item">
        <StaticImage
          src="../images/Skeptical Extravaganza.jpg"
          alt="A Skeptical Extravaganza of Special Significance"
          height="100%"
          loading="lazy"
          placeholder="tracedSVG"
          className="ex-event-img"
          />
        <div className="ex-event-text">
        <h2>
        A Skeptical Extravaganza of Special Significance
          </h2>
          <h5>
            <p>Friday, June 12th | 9:15 PM–11:15 PM </p>
          </h5>
          <p>
          A Skeptical Extravaganza of Special Significance is an interactive stage show from the award winning Skeptics' Guide to the Universe podcast. With musician and fellow podcaster George Hrab as your host, the team uses improv games, illusions, and playful challenges to reveal how easily perception and memory can be fooled. The audience takes part throughout, solving puzzles, joining experiments and trying to beat the SGU at trivia. Expect sharp improv, live music, and counterintuitive tests to see just how easily their brain can fool them. Suitable for curious minds and families with older kids. Typical runtime is about two hours. The cast includes the co-hosts of The Skeptics’ Guide to the Universe podcast – Steven Novella, Jay Novella, Cara Santa Maria, Bob Novella and Evan Bernstein. <p><b>Admission for this event is $99.</b></p>        
          </p>
        </div>
        </div>
        <div className="ex-event-item">
        <StaticImage
          src="../images/Ele Tower Cirtscape Sunset.jpg"
          alt="50th Anniversary Awards Dinner & Mystifying Variety Show"
          height="100%"
          loading="lazy"
          placeholder="tracedSVG"
          className="ex-event-img"
          />
        <div className="ex-event-text">
        <h2>
        50th Anniversary Awards Dinner & Mystifying Variety Show
          </h2>
          <h5>
            <p>Saturday, June 13th | 6:00 PM–8:00 PM </p>
          </h5>
          <p>
          Don't miss the 50th Anniversary Awards Dinner & Mystifying Variety Show! Enjoy dinner, drinks, music, and experience the 50th anniversary celebration of the Committee for Skeptical Inquiry and Skeptical Inquirer magazine (both began in 1976). The evening will be filled with mystifying magic, skeptical comedy, celebratory music, and appreciation for science communication. With Jim Underdown as the host, special guests include Leighann Lord, Richard Wiseman, George Hrab, Malorie Mackey, Daniel Reed, Bertha Vazquez, Peter Hotez, and Michael Mann. Dress up like it’s 1976, 2026, or even 2076 – the choice is yours!

          <p>
          Dinner options will be chicken or vegan. <b>Open Seating is $99</b>; <b>Preferred Seating is $199</b> and also extends to the subsequent presentation by Bill Nye.
          </p>   
          </p>
        </div>
        </div>
        <div className="ex-event-item">
        <StaticImage
          src="../images/niagara-falls-ny.jpg"
          alt="Niagara Falls Excursion and Maid of the Mist Boat Ride"
          height="100%"
          loading="lazy"
          placeholder="tracedSVG"
          className="ex-event-img"
          />
        <div className="ex-event-text">
          <h2>
          Niagara Falls Excursion and Maid of the Mist Boat Ride
          </h2>
          <h5>
            <p>Sunday, June 14th | 1:00 PM–5:00 PM [Sold Out] </p>
          </h5>
          <p>
          Experience breathtaking views of Niagara Falls from the deck of the Maid of the Mist as the boat ferries from the American side to the “basin of Horseshoe Falls — the dramatic passage leading you through the roiling waterfall whitewater and massive rock formations” (you don’t even need a passport). Test your knowledge of science-themed trivia during the 30-minute bus ride to (or from) the falls with Brian Dunning – host of the Skeptoid podcast and leader of the Skeptoid Adventures tours – and some spooky trivia with Kenny Biddle – CSI’s Chief Investigator of Paranormal Claims. Discover Houdini’s connection to Niagara Falls while you explore the roar! Which CSICON speakers will join the journey? There’s only one way to find out! <p><b>Admission for this event is $125 and includes travel to and from Niagara Falls.</b></p>   
          </p>
        </div>
        </div>
        
        
      </main>
    </div>
      <a href="/registration/" className="btn green-button-outline">
      Remember to Add These Events to Your Registration!
      </a>
      </div>
  </Layout>
)

export default ExtraEventPage
